'use client'

import Link from 'next/link'
import Reveal from '../Reveal'

export default function CTA() {
  return (
    <section className="relative py-16">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl ring-1 ring-electric-500/30 bg-gradient-to-br from-steel-800/90 via-ink-card to-ink-soft px-8 sm:px-14 py-14 text-center shadow-glow-lg">
            <div className="absolute -top-24 left-1/2 -translate-x-1/2 w-[500px] h-[500px] rounded-full bg-electric-500/20 blur-[120px] pointer-events-none" />
            <div className="absolute inset-0 bg-grid opacity-40 pointer-events-none" />
            <div className="relative z-10">
              <h2 className="font-display font-bold text-3xl sm:text-5xl text-chrome leading-tight">
                Put your crypto to work.
              </h2>
              <p className="mt-5 text-steel-300 max-w-xl mx-auto text-lg">
                Join 380,000+ borrowers unlocking liquidity without giving up their
                assets. Your credit line is minutes away.
              </p>
              <div className="mt-9 flex flex-col sm:flex-row gap-4 justify-center">
                <Link
                  href="/register"
                  className="btn-shimmer inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl font-semibold bg-gradient-to-b from-electric-400 to-electric-600 text-white shadow-glow hover:shadow-glow-lg transition-shadow"
                >
                  Create free account
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                  </svg>
                </Link>
                <a
                  href="#calculator"
                  className="inline-flex items-center justify-center px-8 py-4 rounded-xl font-semibold glass glass-hover text-steel-100"
                >
                  Estimate a loan
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  )
}
